import React from 'react';
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "../axios";
import { Files } from "../api/api";

import AWS from 'aws-sdk'
import { ParallelHasher } from 'ts-md5';

AWS.config.update({
  accessKeyId: "AKIASVE4SOXEWROEXMW4",
  secretAccessKey: "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",
  region: 'ap-northeast-1'
});

const s3 = new AWS.S3();

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function FileCreate() {
  const navigation = useNavigate();
  const [file, setFile] = useState<Files>({});
  const [progress, setProgress] = useState<string>("");

  const handleCreate = () => {
    console.log("Create");
    axios
      .post("/files", file)
      .then((res) => {
        console.log("post result:" + res);
        navigation("/files");
      })
      .catch((err) => {
        alert(err.response.data.message);
      });
  };

  const uploadFile = (upload: any) => {
    setProgress("0%");
    const hasher = new ParallelHasher('/md5_worker.js');
    hasher.hash(upload).then(function(md5) {
      console.log('md5 of fileBlob is', md5);
      try {
        const params = {
          Bucket: "mdm-images",
          Key: upload.name,
          ContentType: upload.type,
          Body: upload,
        };

        s3.upload(params, function(err: any, data: any) {
          if (err) {
            console.log('Error', err);
            return false;
          }
          console.log('Sucess!');
          setProgress("Success!");
          setFile({ ...file, file_path: upload.name as string, file_hash: md5 as string });
          return true;
        }).on('httpUploadProgress', function(progress) {
          const progressPercentage = Math.round(progress.loaded / progress.total * 100);
          setProgress(progressPercentage.toString() + "%");
        });
      } catch (error) {
        console.log(error);
        alert(error);
        return;
      }
    });
  }

  const handleUpload = (event: any) => {
    console.log("Upload", event.target.files[0]);
    uploadFile(event.target.files[0]);
  }

  const handleChangeAppId = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setFile({ ...file, app_id: event.target.value });
  };

  const handleChangeFileKey = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setFile({ ...file, file_key: event.target.value });
  };

  const handleChangeFileVersion = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setFile({ ...file, file_version: event.target.value });
  };

  const handleChangeFilePath = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setFile({ ...file, file_path: event.target.value });
  };

  const handleChangeFileHash = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    setFile({ ...file, file_hash: event.target.value });
  };
  return (
    <Dashboard title="ファイル登録">
      <Table >
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="アプリID"
                variant="outlined"
                required
                fullWidth
                value={file.app_id}
                onChange={handleChangeAppId}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="ファイルキー"
                variant="outlined"
                required
                fullWidth
                value={file.file_key}
                onChange={handleChangeFileKey}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="ファイルバージョン"
                variant="outlined"
                required
                fullWidth
                value={file.file_version}
                onChange={handleChangeFileVersion}
              />
            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>
              <TextField
                label="ファイルパス"
                variant="outlined"
                required
                fullWidth
                value={file.file_path}
                onChange={handleChangeFilePath}
                InputLabelProps={{ shrink: true }}
                inputProps={{ readonly: true, disabled: true }}
              />
              <br/>
              <br/>
              <input
                style={{ display: 'none' }}
                id="raised-button-file"
                type="file"
                onChange={handleUpload}
              />
              <label htmlFor="raised-button-file">
                <Button color="primary" variant="contained" component="span">
                  Upload
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;{progress}
              </label>

            </TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell align="left">
              <TextField
                label="ファイルハッシュ"
                variant="outlined"
                fullWidth
                value={file.file_hash}
                onChange={handleChangeFileHash}
                InputLabelProps={{ shrink: true }}
                inputProps={{ readonly: true, disabled: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleCreate} sx={{ m: 1 }}>
          CREATE
        </Button>
      </Grid>
    </Dashboard>
  );
}
